import { BASE_URL } from '@avanta/shared/constants/common';
import { service } from '@avanta/shared/services/api';
import { getAnonymousToken } from '@avanta/shared/services/auth';
import { type Enterprise } from '@avanta/shared/types/enterprises';
import { type AxiosResponse } from 'axios';
import { getAnonymousTokenCookie } from 'utils/storage';

const ENTERPRISES_URL = `${BASE_URL}enterprises`;

interface EnterprisesServiceTypes {
  getEnterpriseById: (enterpriseId: string) => Promise<AxiosResponse<Enterprise>>;
}

export const EnterprisesService: EnterprisesServiceTypes = {
  getEnterpriseById: async enterpriseId => {
    const anonymousToken =
      getAnonymousTokenCookie() || (await getAnonymousToken())?.data.access_token;
    return service.get(`${ENTERPRISES_URL}/${enterpriseId}`, {
      headers: { Authorization: `Bearer ${anonymousToken}` },
    });
  },
};
